import { Injectable } from '@angular/core';
import { Constants } from './constants';
import { Utils } from './utils';

@Injectable({
    providedIn: 'root'
})
export class MemoryStorage {
    private cache: Map<string, any> = new Map();

    constructor(private constants: Constants, private utils: Utils) {}

    /**
     * Store data in browser memory (lost on page refresh)
     */
    set(key: string, value: any): void {
        this.cache.set(key, value);
    }

    /**
     * Retrieve data from browser memory
     */
    get(key: string): any {
        const val = this.cache.get(key);
        return this.utils.isEmpty(val) ? this.constants.BLANK : val;
    }

    /**
     * Remove specific key
     */
    remove(key: string): void {
        this.cache.delete(key);
    }

    /**
     * Clear all memory storage
     */
    clear(): void {
        this.cache.clear();
    }
}
